import { Col, Input, Row } from 'reactstrap';
import PropTypes from 'prop-types';

const FiltrosFila1 = ({
  searchMatState,
  isTableNotLoading,
  name,
  lastname,
  dni,
  email,
  idRequest,
  handleNameOnChange,
  handleLastNameOnChange,
  handleDNIOnChange,
  handleEmailOnChange,
  handleIDOnChange,
}) => {
  const hasRestoredSearch = searchMatState != null && searchMatState.newSearch === false;

  return (
    <Row className="mt-md-3" style={{ alignItems: 'flex-end' }}>
      <Col sm="2" className="mt-1 mt-md-0">
        <label htmlFor="name" className="form-label">
          Nombre
        </label>
        <Input
          type="text"
          name="name"
          id="name"
          placeholder="Buscar por nombre"
          onChange={handleNameOnChange}
          onInput={handleNameOnChange}
          className={name.error !== '' ? 'border border-danger error' : ''}
          defaultValue={hasRestoredSearch ? name.data : undefined}
          disabled={!isTableNotLoading}
        />
        {name.error === 'length' && (
          <span className="text-danger tiny">Debe tener mínimo 2 caracteres</span>
        )}
        {name.error === 'format' && (
          <span className="text-danger tiny">Números o símbolos no permitidos</span>
        )}
      </Col>
      <Col sm="3" className="mt-1 mt-md-0">
        <label htmlFor="lastname" className="form-label">
          Apellidos
        </label>
        <Input
          type="text"
          name="lastname"
          id="lastname"
          placeholder="Buscar por apellidos"
          onChange={handleLastNameOnChange}
          onInput={handleLastNameOnChange}
          className={lastname.error !== '' ? 'border border-danger error' : ''}
          defaultValue={hasRestoredSearch ? lastname.data : undefined}
          disabled={!isTableNotLoading}
        />
        {lastname.error === 'length' && (
          <span className="text-danger tiny">Debe tener mínimo 2 caracteres</span>
        )}
        {lastname.error === 'format' && (
          <span className="text-danger tiny">Números o símbolos no permitidos</span>
        )}
      </Col>
      <Col sm="2" className="mt-1 mt-md-0">
        <label htmlFor="dni" className="form-label">
          DNI
        </label>
        <Input
          type="text"
          name="dni"
          id="dni"
          placeholder="Buscar por DNI"
          onChange={handleDNIOnChange}
          onInput={handleDNIOnChange}
          className={dni.error !== '' ? 'border border-danger error' : ''}
          defaultValue={hasRestoredSearch ? dni.data : undefined}
          disabled={!isTableNotLoading}
        />
        {dni.error === 'format' && <span className="text-danger tiny">Formato incorrecto</span>}
      </Col>
      <Col sm="3">
        <label htmlFor="email" className="form-label">
          Correo electrónico
        </label>
        <Input
          type="email"
          name="email"
          id="email"
          placeholder="Buscar por Email"
          onChange={handleEmailOnChange}
          onInput={handleEmailOnChange}
          className={email.error !== '' ? 'border border-danger error' : ''}
          defaultValue={hasRestoredSearch ? email.data : undefined}
          disabled={!isTableNotLoading}
        />
        {email.error === 'format' && <span className="text-danger tiny">Formato incorrecto</span>}
      </Col>
      <Col sm="2">
        <label htmlFor="idRequest" className="form-label">
          ID
        </label>
        <Input
          type="text"
          name="idRequest"
          id="idRequest"
          placeholder="ID"
          onChange={handleIDOnChange}
          onInput={handleIDOnChange}
          className={idRequest.error !== '' ? 'border border-danger error' : ''}
          defaultValue={hasRestoredSearch ? idRequest.data : undefined}
          disabled={!isTableNotLoading}
        />
        {idRequest.error === 'format' && (
          <span className="text-danger tiny">Formato incorrecto</span>
        )}
      </Col>
    </Row>
  );
};

FiltrosFila1.propTypes = {
  searchMatState: PropTypes.object,
  isTableNotLoading: PropTypes.bool,
  name: PropTypes.shape({ data: PropTypes.string, error: PropTypes.string }),
  lastname: PropTypes.shape({ data: PropTypes.string, error: PropTypes.string }),
  dni: PropTypes.shape({ data: PropTypes.string, error: PropTypes.string }),
  email: PropTypes.shape({ data: PropTypes.string, error: PropTypes.string }),
  idRequest: PropTypes.shape({ data: PropTypes.string, error: PropTypes.string }),
  handleNameOnChange: PropTypes.func,
  handleLastNameOnChange: PropTypes.func,
  handleDNIOnChange: PropTypes.func,
  handleEmailOnChange: PropTypes.func,
  handleIDOnChange: PropTypes.func,
};

export default FiltrosFila1;
